fragment AsSeenInFragment on asSeenIn_Entry {
  typeHandle
  heading
  backgroundColorGreen
  asSeenInLogos: logos {
    ... on asSeenInLogosBlock_Entry {
      image {
        url
        title
      }
      alt
    }
  }
}
